import { createContext, useState } from "react";

export const GlobalContext = createContext();

export const GlobalContextProvider = ({ children }) => {
  const [GlobalState, setGlobalState] = useState({
    userLoggin: "false",
    path: "",
    navBarOpen: false,
    vista: "Registro Usuarios",
    noticiasComponent: false,
    modalAlumno: false,
    buscar: false,
    rolInscripcion: "Alumno",
    formatoDetalle:
      "dHlPZzF6Y2Z5SnNBVjhaZlZuK0graTNtYXQ2TXZ5WmwzRkF2QmxNNFZQMD0=",
    lineaCaptura: {
      CONCEPTOPLINEA: "",
      FECHAPLINEA: "",
      FORMATO:
        "",
      IMPORTE: "",
      LINEA_CAPTURA: "",
      TOKEN:
        "",
    }, 
    openpagoLinea: false,
  });

  return (
    <GlobalContext.Provider
      value={{
        GlobalState,
        setGlobalState,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
